import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { useToast } from '../../ui/feedback';
import { StatusChip } from '../../ui/primitives';

const INTEGRATIONS = [
  {
    name: 'Identity verification',
    vendor: 'GreenID / FrankieOne (to choose)',
    status: 'OPEN',
    detail:
      'Electronic ID checks, document verification, PEP and sanctions screening with daily re-screening.',
  },
  {
    name: 'Bank feed',
    vendor: 'Bank API or daily statement file',
    status: 'OPEN',
    detail: 'Receipts into each fund applications account for automatic matching.',
  },
  {
    name: 'Payments out',
    vendor: 'ABA file (v1), bank API (phase 2)',
    status: 'OPEN',
    detail: 'Distribution and redemption payments after approval.',
  },
  {
    name: 'BPAY',
    vendor: 'Biller code per fund',
    status: 'OPEN',
    detail: 'Unique customer reference numbers per holder per call.',
  },
  {
    name: 'ATO lodgement',
    vendor: 'SBR (Standard Business Reporting)',
    status: 'PENDING',
    detail: 'AIIR, TFN report, FATCA and CRS. Requires software developer registration.',
  },
  {
    name: 'Fund accounting',
    vendor: 'Xero / fund administrator',
    status: 'PENDING',
    detail: 'Import tax components and NAV unit prices; export register movements.',
  },
  {
    name: 'E-signature',
    vendor: 'Native in-app signing',
    status: 'OPEN',
    detail: 'Application forms, transfer forms and certificates.',
  },
  {
    name: 'Notifications',
    vendor: 'Existing platform (push, email)',
    status: 'OPEN',
    detail: 'Notices, advices, reminders and tasks reuse the current notification service.',
  },
  {
    name: 'Webhooks and API',
    vendor: 'For white-label clients',
    status: 'NOT_STARTED',
    detail: 'Register events for client CRMs and data warehouses.',
  },
];

export default function IntegrationsTab() {
  const toast = useToast();
  return (
    <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
      {INTEGRATIONS.map((item) => (
        <Paper key={item.name} variant="outlined" sx={{ p: 2.5 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
            <Box>
              <Typography variant="h6">{item.name}</Typography>
              <Typography variant="caption" color="text.secondary">
                {item.vendor}
              </Typography>
            </Box>
            <StatusChip
              status={item.status}
              label={
                item.status === 'OPEN'
                  ? 'Connected (demo)'
                  : item.status === 'PENDING'
                    ? 'Set-up required'
                    : 'Planned'
              }
            />
          </Stack>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {item.detail}
          </Typography>
          <Button
            size="small"
            sx={{ mt: 1, ml: -1 }}
            onClick={() => toast(`${item.name} configuration (not wired in the prototype)`, 'info')}
          >
            Configure
          </Button>
        </Paper>
      ))}
    </Box>
  );
}
